module.exports = __webpack_public_path__ + "static/Damien Tran.5ad21ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Damien Tran.jpg
// module id = 1209
// module chunks = 6166952557895